import { HttpClient } from "@angular/common/http";
import { EventEmitter, Injectable } from "@angular/core";
import { ApiPaginationResponseDataNonNullable } from "app/shared/models/api-response.model";
import { Observable } from "rxjs";
import { AuthService } from "../../base-module/base-service/auth.service";
import { UtilitesService } from "../../base-module/base-service/utilites.service";
import { TipoLance } from "../models/tipo-lance.model";

@Injectable()
export class TipoLanceCartaConsorcioService {
    public empresaPadrao = new EventEmitter<any>();

    constructor(private authService: AuthService, private _http: HttpClient, public utilitesService: UtilitesService) {}

    /**
     * Tipo Lance da Carta Consórcio por id
     * @param id ID da Tipo Lance da Carta Consórcio
     */
    getById(id: number): Observable<any> {
        return this._http.get(this.utilitesService.urlPrefix + "consorcio/carta-tipo-lance/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Lista de Tipo Lance da Carta Consórcio
     * @param id ID da Tipo Lance da Carta Consórcio
     */
    getAll(params: any): Observable<ApiPaginationResponseDataNonNullable<TipoLance>> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get<ApiPaginationResponseDataNonNullable<TipoLance>>(
            this.utilitesService.urlPrefix + "consorcio/carta-tipo-lance" + env,
            { headers: this.authService.getAuthHeaders() }
        );
    }

    /**
     * Lista de Tipo Lance da Carta Consórcio
     * @param id ID da Tipo Lance da Carta Consórcio
     */
    search(params: any): Observable<any> {
        const paramHttp = this.utilitesService.formurlencoded(params);
        let env = "";
        if (paramHttp != null && paramHttp != "") {
            env = "?" + paramHttp;
        }

        return this._http.get(this.utilitesService.urlPrefix + "consorcio/carta-tipo-lance" + env, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Delete de Tipo Lance da Carta Consórcio
     * @param id ID da Tipo Lance da Carta Consórcio
     */
    delete(id: number): Observable<any> {
        return this._http.delete(this.utilitesService.urlPrefix + "consorcio/carta-tipo-lance/" + id, {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Cadastra Tipo Lance da Carta Consórcio
     * @param params Json Tipo Lance da Carta Consórcio
     */
    create(params: any): Observable<any> {
        return this._http.post(this.utilitesService.urlPrefix + "consorcio/carta-tipo-lance", JSON.stringify(params), {
            headers: this.authService.getAuthHeaders(),
        });
    }

    /**
     * Atualiza Tipo Lance da Carta Consórcio
     * @param params Json Tipo Lance da Carta Consórcio
     */
    update(id: number, params: any): Observable<any> {
        return this._http.put(
            this.utilitesService.urlPrefix + "consorcio/carta-tipo-lance/" + id,
            JSON.stringify(params),
            { headers: this.authService.getAuthHeaders() }
        );
    }
}
